/**
 * Notification domain types — mirrors the shape returned by
 * `GET /api/users/me/notifications` (NotificationResDto).
 *
 * Channel / Type codes match the backend enums:
 *  channel: 0=EMAIL, 1=SMS, 2=PUSH
 *  type:    see NotificationType enum (education/exam/certificate/etc.)
 *
 * Raw controller response is double-wrapped by the HTTP layer:
 *   axios.data -> { status, data: { success, status, data: {...}, message } }
 * The API service normalises this so the UI gets a flat `NotificationListResult`.
 */

export enum NotificationChannel {
  EMAIL = 0,
  SMS = 1,
  PUSH = 2,
}

/** Backend NotificationType enum (kept in sync with notifications/enums/notification-type.enum.ts). */
export enum NotificationType {
  VERIFICATION = 0,
  PASSWORD_RESET = 1,
  OTP = 2,
  GENERAL = 3,
  ALERT = 4,
  MARKETING = 5,
  CERTIFICATE_ISSUED = 6,
  EXAM_ELIGIBLE = 7,
  EXAM_COMPLETED = 8,
  SURVEY_ELIGIBLE = 9,
  SURVEY_COMPLETED = 10,
  EDUCATION_UPCOMING_30D = 11,
  EDUCATION_UPCOMING_7D = 12,
  EDUCATION_UPCOMING_1D = 13,
  ENROLLMENT_REJECTED_FINAL = 14,
  TICKET_REPLIED = 15,
  EDUCATION_OPENED = 16,
}

export interface NotificationItem {
  id: string;
  /** May arrive as a numeric enum or a string (ApiGetAll serialization). */
  type: NotificationType | number | string;
  channel: NotificationChannel | number;
  title: string | null;
  message: string;
  sent: boolean;
  sentAt: string | null;
  readAt: string | null;
  entityType: string | null;
  entityId: string | null;
  data: Record<string, unknown> | null;
  createdAt: string;
}

export interface NotificationListParams {
  page?: number;
  limit?: number;
  unreadOnly?: boolean;
}

export interface NotificationListResult {
  items: NotificationItem[];
  count: number;
  unreadCount: number;
  page: number;
  limit: number;
}

export interface NotificationPreference {
  channel: NotificationChannel | number;
  enabled: boolean;
}
